import mapFunction from './mapResources';

export default mapFunction('subscriptions', {
    isFetching: false,
    items: [] 
});